import Vue from 'vue';

import Queue from '@/utils/queue';


export default new Queue<Vue>(true);